import { useMutation } from '@tanstack/react-query'
import { useNavigate } from '@tanstack/react-router'
import { Request } from 'commons/utils/request'
import { useConfirmation } from 'ui/hooks'

import { handlerServerError } from '@orbit/errors'

export const useBsaBatchDetails = (id?: number) => {
  const navigate = useNavigate()

  const { mutate: deleteBatch } = useMutation({
    mutationFn: (id: number) => Request.delete(Request.urls.bank.bsaBatch, { id }),
    onSuccess: async () => {
      navigate({ to: '/bsa/sar-batch-list' })
    },
    onError: (error) => handlerServerError(error)
  })

  const { open: startDeleting, Confirmation: DeleteConfirmation } = useConfirmation({
    message: `Are you sure you want to delete ${id || 'this'} Batch?`,
    onConfirm: () => deleteBatch(id!),
    confirmationButtonText: 'Delete',
    isConfirmationNegative: true
  })

  return {
    startDeleting,
    DeleteConfirmation
  }
}
